
















































import Group from '@/types/Group.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        exclude: {
            type: Array,
            default: null
        },
        expand: {
            type: Boolean,
            default: false
        },
        groups: {
            type: Array as PropType<Group[]>,
            default: []
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        viewMore: false
    }),
    computed: {
        //  Depending on our screen size we either render 2 or 3 rows to have the broadcast component better fit the screen
        allowedRows(): number {
            if (this.$vuetify.breakpoint.smAndDown){
                return 2
            }
            else {
                return 3
            } 
        },
        filteredGroups(): Group[] {
            //  Grab our groups
            const groups = this.groups

            //  If there aren't any return empty array
            if (!groups) return []

            //  Else, check if we have any groups to exclude
            const exclude = this.exclude || []

            //  Make sure we exclude all of these groups
            const filtered = groups.filter(({ id }) => !exclude.includes(id))

            //  Return our filtered groups
            return filtered
        }
    },
    methods: {
        onGroupSelected(group: Group): void {
            //  Tell the parent about our selection
            this.$emit('groupSelected', group)
        }
    }
})
